import React, { Component } from "react";
import { observer } from "mobx-react";
import queryString from "query-string";
import Button from "components/Button";

class AuthFormPasswordNewSaved extends Component {
  render() {
    const { className } = this.props;

    const query = queryString.parse(window.location.search);

    return (
      <div className={[className, "text-center"].join(" ")}>
        <strong>Vielen Dank!</strong>
        <br />
        <br />
        Ihr neues Passwort wurde erfolgreich gespeichert!
        <br />
        <br />
        <Button href={query.redirect}>ZUR ÜBERSICHT</Button>
      </div>
    );
  }
}

AuthFormPasswordNewSaved = observer(AuthFormPasswordNewSaved);

export default AuthFormPasswordNewSaved;
